import type { User } from '../scenes/authentication/types/types.auth.js';

export const pendoInitialize = (user?: User) => {
  if ((import.meta.env.VITE_NO_PENDO && import.meta.env.VITE_NO_PENDO === 'true') || import.meta.env.VITE_ENV === 'ci') {
    return;
  }

  try {
    if (window.pendo) {
      const account = user
        ? {
          company: user.company,
          companySize: user.companySize,
          createdAt: user.createdAt,
          deepDivesAvailableInSubPeriod: user.deepDivesAvailableInSubPeriod,
          deepDivesSubmittedInSubPeriod: user.deepDivesSubmittedInSubPeriod,
          deepDivesViewedInSubPeriod: user.deepDivesViewedInSubPeriod,
          id: user.id,
          industry: user.industry,
          planDeepDiveReviewLimit: user.planDeepDiveReviewLimit,
          planSlug: user.planSlug,
        }
        : {};
      const visitor = user
        ? {
          email: user.email,
          firstName: user.firstName,
          id: user.id,
          lastName: user.lastName,
          positionTitle: user.positionTitle,
        }
        : {};

      window.pendo.initialize({
        account,
        visitor,
      });
    }
  }
  catch {
    // Silent fail for Pendo initialization
  }
};
